import { motion } from 'framer-motion';
import { FiMessageCircle } from 'react-icons/fi';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Mr. Umashankar Singh',
    text: 'Shyam delivered an exceptional school management system that transformed our operations. His expertise in PHP and MySQL created a robust platform serving 500+ students efficiently. Professional and deadline-focused throughout.',
  },
  {
    name: 'Mr. Vivek Kr Rai',
    text: 'Working with Shyam on our educational platform was remarkable. His full-stack development knowledge created scalable solutions that exceeded expectations. Highly recommended for any web project.',
  },
  {
    name: 'Sonu Singh',
    text: 'Working with Shyam has been an absolute pleasure. His expertise in web development is unmatched, consistently delivering top-notch results with innovative solutions.',
  },
];

function Testimonials() {
  return (
    <section id="testimonials" className="testimonials section">
      <motion.div className="section-title-wrap" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
        <FiMessageCircle className="section-title-icon" aria-hidden />
        <h2 className="section-title section-title--inline">Valuable Testimonials</h2>
      </motion.div>
      <motion.p
        className="section-subtitle"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        What clients and peers say about working with me.
      </motion.p>
      <div className="testimonials__grid">
        {testimonials.map((t, i) => (
          <motion.blockquote
            key={t.name}
            className="testimonials__card glass"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 * i }}
            whileHover={{ y: -4 }}
          >
            <span className="testimonials__quote">"</span>
            <p className="testimonials__text">{t.text}</p>
            <footer className="testimonials__author">— {t.name}</footer>
          </motion.blockquote>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
